import {Model} from "./base/Model";


    export class TaskUser extends Model  {
        dossierKey: string = "";
        taskKey: string = "";
        userKey: string;
        dayKey: string = "";
        startTime: number;
        endTime: number;
        remain:number = 0;
        workhours: number = 0;
        worktype:string = "";
        state:number = 0;
        comKey:string;
        constructor(data = null) {
            super(data);
            this.createModel(data);
        }      
      
      
      
    }